/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";

import { Meta } from "../blocks/Meta/Meta";
import { DealerPackagesColumns } from "../blocks/PackageEditor/PackageList/DealerPackagesColumns";
import { DealerPackagesHeader } from "../blocks/PackageEditor/PackageList/DealerPackagesHeader";
import { DealerPackagesList } from "../blocks/PackageEditor/PackageList/DealerPackagesList";

export const DealerPackageEditorPage: FunctionComponent = () => {
  return (
    <>
      <Meta cmsTitle={null} title="packageEditor" />
      <DealerPackagesHeader />
      <div className="overflow-auto">
        <div className="min-w-[48rem] grid gap-2">
          <DealerPackagesColumns />
          <DealerPackagesList />
        </div>
      </div>
    </>
  );
};
